import React from 'react'
import style from './index.module.scss'

const getReturnableContent = (
  returnable: boolean | undefined,
  enableBrandUpdate: boolean,
  faqHref?: string
): JSX.Element => {
  if (returnable === false) {
    return (
      <p className={style.content}>
        This item is <span className={style.strong}>not</span> included as part
        of the 14 day return policy and cannot be returned unless faulty. View
        the Westfield {enableBrandUpdate ? 'online ' : 'Direct '}
        <a href={faqHref ?? ''} target="_self" rel="noopener noreferrer">
          return policy
        </a>{' '}
        for more information.
        <br />
        <br />
        Returning in centre? Please return your items at the Westfield{' '}
        {enableBrandUpdate ? 'Click & Collect ' : 'Direct '}
        service desk.
      </p>
    )
  }
  return (
    <p className={style.content}>
      This item is included as part of the 14 day universal returns policy. View
      the Westfield {enableBrandUpdate ? 'online ' : 'Direct '}
      <a href={faqHref ?? ''} target="_self" rel="noopener noreferrer">
        return policy
      </a>{' '}
      for more information.
      <br />
      <br />
      Returning in centre? Please return your items at the Westfield{' '}
      {enableBrandUpdate ? 'Click & Collect ' : 'Direct '}
      service desk.
    </p>
  )
}

export const getAccordionReturnableContent = (
  returnable: boolean | undefined,
  enableBrandUpdate: boolean,
  faqHref?: string
): JSX.Element => {
  return getReturnableContent(returnable, enableBrandUpdate, faqHref)
}
